export const DEFAULT_LOCALE = 'ua';

/** The language a visitor chose on a public page (/m/, /s/) — src/i18n.js. */
export const PUBLIC_LOCALE_STORAGE_KEY = 'fska.public.locale';

export const AVAILABLE_LOCALES = [{
        locale: 'ua',
        label: 'Українська',
    }, {
        locale: 'en',
        label: 'English',
    }]
